import { z } from 'zod'
import { serviceRequest } from '@/lib/api-client'
import {
  applicationSchema,
  type Application,
} from '@/features/onboarding/model/application-schemas'

export const CICD_ACCESS_STALE_EVENT = 'forgesphere:cicd-access-stale'

const accessDataSchema = z.object({
  accessible: z.boolean(),
  manageable: z.boolean(),
  organizationWide: z.boolean(),
  policyRevision: z.string().nullish(),
  applicationIds: z.array(z.string()),
  applications: z.array(applicationSchema),
})

const accessEnvelopeSchema = z.object({
  status: z.literal('SUCCESS'),
  data: accessDataSchema,
})

export type CicdAccess = {
  accessible: boolean
  manageable: boolean
  organizationWide: boolean
  policyRevision: string
  applicationIds: string[]
  applications: Application[]
}

function parseAccess(payload: unknown): CicdAccess {
  const { data } = accessEnvelopeSchema.parse(payload)
  return {
    ...data,
    policyRevision: data.policyRevision?.trim() ?? '',
  }
}

export async function getCicdAccess(): Promise<CicdAccess> {
  const response = await serviceRequest<unknown>('onboarding', {
    method: 'GET',
    url: '/v2/api/authorization/cicd/access',
  })
  return parseAccess(response.data)
}

export async function listCicdApplications(search = ''): Promise<CicdAccess> {
  const response = await serviceRequest<unknown>('onboarding', {
    method: 'GET',
    url: '/v2/api/authorization/cicd/applications',
    params: search.trim() ? { search: search.trim() } : undefined,
  })
  return parseAccess(response.data)
}
